<template>
    <div class="warp">
    <BaseHeader />
         <div class="col-lg-6 offset-lg-3">
        <div class="card-v2">
          <div class="card-head-v2">
            <p class="text-center pm-amount">
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="11" cy="11" r="11" fill="#AB2328" />
                <path
                  d="M9.992 17V9H12.136V17H9.992ZM9.992 7.976V5.8H12.136V7.976H9.992Z"
                  fill="white"
                />
              </svg>
              {{ text.expired }}
            </p>
          </div>
        </div>
      </div>

   </div>
</template>

<script>
export default {
  computed: {
    text() {
      let obj = {}
      if (this.$store.state.language == 'EN') {
        obj = {
          expired: 'This payment link has expired.',
          click: 'Click',
          here: 'here',
          for: 'for back to homepage'
        }
      } else {
        obj = {
          expired: 'ขออภัย ลิงก์สำหรับชำระเงินนี้หมดอายุแล้ว ',
          click: 'คลิก',
          here: 'ที่นี่',
          for: 'เพื่อกลับสู่หน้าชำระเงิน'
        }
      }
      return obj
    }
  }
}
</script>
 